import React, { useEffect, useRef} from "react";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { SiMinutemailer } from "react-icons/si";

import { useSelector, useDispatch } from "react-redux";

import { useLocation, useNavigate } from "react-router-dom";


import { selectSignIn } from "../../store/slices/signed-in-slice";

import { setJobData } from "../../store/slices/job-data-slice";
import { asyncLocalStorage } from "../utils/async-localstorage-helpers";

import {toast} from 'react-toastify';

import { selectProfileStatus } from "../../store/slices/profile-status-slice";


export const IndividualAssessmentDetail = ({individualAssessment}) => {    
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const profileComplete = useSelector(selectProfileStatus);
    const isSignedIn = useSelector(selectSignIn);

    

    // Unescape HTML entities and prevent Cross-Site Scripting XSS vulnerability.
    function htmlDecode(input) {
        var doc = new DOMParser().parseFromString(input, "text/html");
        return doc.documentElement.textContent;
    }

    const copyEmail = async () => {
        await navigator.clipboard.writeText("RecruitDocs@dpm.navajo-nsn.gov");
    };

    
    // const selectedJob = useSelector(selectedJobData);

    // Choose what to scroll to when loading in to the page
    const ref = useRef(null);

    // Extracts pathname property(key) from an object
    const { pathname } = useLocation();

    // Automatically scrolls to top whenever pathname changes
    useEffect(() => {
        ref.current?.scrollIntoView({ behavior: "smooth" });
    }, [pathname]);

    useEffect(() => {
        if(!isSignedIn) {
            navigate('/signin')
        }
    }, [isSignedIn])

    const {
            IA_Reference_ID,
            PositionTitle,
            PositionNumber,
            Location,
            ClosingDate,
            IA_WorkHours,
            IA_WorkDays,
            IA_PayRate,
            IA_EmploymentType,
            IA_Sensitive,
            IA_Department,
            IA_isSubmitted, 
            IA_LetterOfInterest_In,
            
    } = individualAssessment

    return (
        <>
            <Row>
                <Card ref={ref}>
                    <Card.Body>
                        <Card.Title>
                            <Col
                                xs={6}
                                className="d-flex justify-content-start mb-3"
                            >
                                <b>{PositionTitle}</b>
                            </Col>
                        </Card.Title>
                        <Col>{Location}</Col>
                        <Card.Body>
                            <Row className="mb-1">
                                <Col>
                                    <b>Individual Assessment ID:</b> {IA_Reference_ID}
                                </Col>
                            </Row>
                            <Row className="mb-1">
                                <Col>
                                    <b>Position ID:</b> {PositionNumber}
                                </Col>
                                
                            </Row>
                            <Row className="mb-1">
                                <Col>
                                    <b>Department:</b> {IA_Department}
                                </Col>
                            </Row>
                            <Row className="mb-1">
                                <Col>
                                    <b>Sensitive: </b>
                                    {IA_Sensitive}
                                </Col>
                            </Row>
                            <Row className="mb-1">
                                <Col>
                                    <b>Letter of Interest on File: </b>
                                    {IA_LetterOfInterest_In}
                                </Col>
                            </Row>
                            {IA_LetterOfInterest_In === "No" && (
                                <Row className="">
                                    <Col>
                                        <b>&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;</b>
                                        <mark>Please email your Letter of Interest to DPM at&nbsp; 
                                            <a className="footer-link" style={{color: "blue"}} onClick={copyEmail}>
                                                <SiMinutemailer /> RecruitDocs@dpm.navajo-nsn.gov
                                            </a>
                                        </mark>
                                    </Col>
                                </Row>
                            )}
                            
                        </Card.Body>
                        
                        
                        <Row>
                            {IA_isSubmitted === "No" && (<Col xs={6}>
                                {isSignedIn && (
                                    <Button
                                        variant="primary"
                                        onClick={() => {
                                            localStorage.setItem("storedJob", JSON.stringify({
                                                    requisitionID: IA_Reference_ID,
                                                    positionNumber:
                                                        PositionNumber,
                                                    positionTitle:
                                                        PositionTitle,
                                                    closingDate: ClosingDate,
                                                    location: Location,
                                                    // workHours: IA_WorkHours,
                                                    // workDays: IA_WorkDays,
                                                    // payRate: IA_PayRate,
                                                    // employmentType:
                                                    //     IA_EmploymentType,
                                                    sensitive: IA_Sensitive,
                                                    department: IA_Department,
                                                    isIndividualAssessment: true
                                            }))
                                        if(profileComplete) {
                                            // navigate(`/applicationSubmit?individual_assessment=${IA_Reference_ID}`);
                                            navigate('/profileCard')
                                        } else {
                                            toast.warning("Profile Incomplete. Please complete profile.", {theme: "colored", closeOnClick: true, autoClose: 5000, position: "top-center", containerId: "root"})
                                            navigate("/profileCard");
                                        }
                                        }}
                                    >
                                        Complete Assessment
                                    </Button>
                                )}
                            </Col>)}
                            {IA_isSubmitted === "Yes" && (<Col xs={6}>
                                {isSignedIn && (
                                    <Button
                                        variant="success"
                                        onClick={() => {
                                            navigate(`/application`);
                                        
                                        }}
                                    >
                                        Assessment Completed. Check Status
                                    </Button>
                                )}
                            </Col>)}
                        </Row>
                    </Card.Body>
                </Card>
            </Row>
        </>
    )
}